import React from 'react';
import PropTypes from 'prop-types';
import AirplaneSeat from '../../../icons/AirplaneSeatIcon';
import ClassNames from 'classnames';

const RowSeats = ({ row, rowNumber, middleRow, selectSeat, selectedPassenger }) =>
  row.map((seat, index) => (
    <div
      className='seat'
      key={`row-${rowNumber}-seat-${seat ? seat.id : ''}-${index}`}
      id={`${seat.row}#${seat.seatNum}`}
      onClick={() => selectSeat(seat)}
    >
      <AirplaneSeat
        className={ClassNames({
          selected: seat.passenger,
          active: seat.passenger === selectedPassenger,
          reserved: !seat.available && seat.status === 'reserved',
          'not-available': !seat.available,
        })}
      />

      {middleRow === index ? (
        <span className='row-number'>
          {rowNumber < 10 ? <span>&nbsp;</span> : null}
          {rowNumber}
        </span>
      ) : null}
    </div>
  ));

RowSeats.propTypes = {
  row: PropTypes.arrayOf(PropTypes.object),
  rowNumber: PropTypes.number,
  middleRow: PropTypes.number,
  selectedPassenger: PropTypes.string,
  selectSeat: PropTypes.func,
};

export default RowSeats;



// WEBPACK FOOTER //
// ./src/components/seats/seatSelection/RowSeats.js